import Query from '../../../components/Report';

export const query = (branded_terms) =>
    new Query('search-summary-branded', {
        branded_terms: `(${branded_terms})`,
    });

